module.exports = __webpack_public_path__ + "static/img/4.eddf9c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/zh/4.png
// module id = jMCg
// module chunks = 0